export const primaryButtonPressed = (
  e: MouseEvent | React.MouseEvent
): boolean => ((e.buttons ?? (e as MouseEvent).which) & 1) === 1
